import WebOperationListListResultModelBase from '../_generated/modelBases/web-operation-list-list-result-model-base';

export default class WebOperationListListResultModel extends WebOperationListListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
